// AUTO-GENERATED by scripts/gen-keyword-tops.mjs — do not edit by hand.

export const NOTARY_KEYWORDS_TOP: string[] = [
  "notary public",
  "notary public thailand",
  "notary public bangkok",
  "notary thailand",
  "ทนาย notary public",
  "รับรองเอกสาร notary public",
  "notary public คือ",
  "บริการ notary public",
  "ทนายรับรองเอกสาร",
  "notary public ราคา",
  "notary public ใกล้ฉัน",
  "รับทำ notary public",
  "notary public lawyer thailand",
  "notary services bangkok",
  "notary public service",
  "รับรองลายมือชื่อ",
  "รับรอง notary public",
  "ทนายความ notary public",
  "notary public สุขุมวิท",
  "notary public สีลม",
  "notary public สาทร",
  "notary public อโศก",
  "notary public รัชดา",
  "notary public พัทยา",
  "notary public ภูเก็ต",
  "notary public เชียงใหม่",
  "notary public นนทบุรี",
  "notary public ชลบุรี",
  "notary public สมุทรปราการ",
  "notary public ขอนแก่น",
  "notary public โคราช",
  "notary public อุดรธานี",
  "notary public ระยอง",
  "notary public หัวหิน",
  "notary public สมุย",
  "notary public near me",
  "english speaking notary bangkok",
  "certified notary public thailand",
  "notarial services attorney",
  "notarial services attorney thailand",
  "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
  "รับรองสำเนาถูกต้อง notary",
  "รับรองเอกสารไปต่างประเทศ",
  "notary public กระทรวงการต่างประเทศ",
  "กรมการกงสุล notary public",
  "รับรองเอกสาร กงสุล notary",
  "รับรองเอกสาร สถานทูต notary",
  "notary public แปลเอกสาร",
  "แปลและรับรองเอกสาร notary",
  "รับแปลเอกสาร notary public",
  "notary public เอกสารบริษัท",
  "notary public หนังสือรับรองบริษัท",
  "notary public งบการเงิน",
  "notary public passport",
  "notary public บัตรประชาชน",
  "notary public ทะเบียนบ้าน",
  "notary public ใบเกิด",
  "notary public สูติบัตร",
  "notary public ใบสมรส",
  "notary public ทะเบียนสมรส",
  "notary public ใบหย่า",
  "notary public ใบเปลี่ยนชื่อ",
  "notary public โฉนดที่ดิน",
  "notary public สัญญา",
  "notary public หนังสือมอบอำนาจ",
  "notary public power of attorney",
  "notary public affidavit",
  "notary public bank statement",
  "notary public degree certificate",
  "notary public transcript",
  "รับรองวุฒิการศึกษา notary public",
  "notarize document bangkok",
  "notarize document thailand",
  "how to notarize a document in thailand",
  "where to get document notarized in bangkok",
  "cheap notary public bangkok",
  "notary public cost bangkok",
  "notary public fee thailand",
  "ค่าทำ notary public",
  "notary public ราคาถูก",
  "notary public ด่วน",
  "urgent notary public bangkok",
  "same day notary thailand",
  "mobile notary bangkok",
  "notary public นอกสถานที่",
  "notary public วันอาทิตย์",
  "notary public เปิดเสาร์อาทิตย์",
  "notary public 24 hours bangkok",
  "us embassy bangkok notary",
  "uk embassy bangkok notary",
  "australian embassy bangkok notary",
  "canadian embassy bangkok notary",
  "notary public for usa",
  "notary public for uk",
  "notary public for australia",
  "apostille thailand",
  "legalisation thailand",
  "รับรองเอกสาร apostille",
  "public notary หรือ notary public",
  "สำนักงานทนายความ notary public",
  "โนตารีพับลิค",
  "ทนายโนตารี",
  "บริการโนตารีพับลิค",
  "รับรองเอกสาร โนตารี",
  "ทนายรับรองสำเนา",
  "ผู้ทำคำรับรองลายมือชื่อ",
  "รับรองลายมือชื่อ กรรมการบริษัท",
  "รับรองลายมือชื่อ บุคคลธรรมดา",
  "certified true copy bangkok",
  "certified true copy thailand",
  "witness signature thailand",
  "witness signature bangkok",
  "document certification bangkok",
  "document legalization thailand",
  "lawyer sign document thailand",
  "notary service fee bangkok",
  "notary public prices in thailand",
  "notary public online thailand",
  "online notary thailand",
  "e-notary thailand"
];
export const NOTARY_KEYWORDS_TOP_TOTAL = 500;
